import { DaymapIcon, DaymapIconType, useStudent, ClassesList, useAppState, StudentYearSelect } from "daymap-react";
import { PageContainer, PageDescriptor } from "../../../components/layout";
import { useNavigate, useParams } from "react-router-dom";
import { Box, Stack } from "@mui/material";

export function Classes() {
    const { studentId } = useParams();
    const navigate = useNavigate();
    const student = useStudent(Number(studentId));
    const [state, setState] = useAppState<{ year: number | 'current' }>(`Classes_${studentId}`, { year: 'current' }, "session");
    const { year } = state;

    const handleYearChange = (newYear: number) => {
        setState({ year: newYear === 0 ? 'current' : newYear });
    };

    const handleClassClick = (classId: number, year?: number) => {
        if (year) {
            navigate(`/student/${studentId}/classes/${classId}/${year}`);
        } else {
            navigate(`/student/${studentId}/classes/${classId}`);
        }
    };

    // Convert 'current' to 0 for StudentYearSelect
    const yearForSelector = year === 'current' ? 0 : year;

    return <PageContainer>
        <PageDescriptor icon={<DaymapIcon iconType={DaymapIconType.Class} />} title="Classes">
            View all {student?.Displayname}'s classes for the selected time frame
        </PageDescriptor>

        <Box pt={2}>
            <StudentYearSelect 
                studentId={Number(studentId)} 
                year={yearForSelector} 
                onChange={handleYearChange}
                includeSpecial={true}
                specialLabel="Current"
            />
        </Box>

        <Stack spacing={1} mt={2}>
            <ClassesList studentId={Number(studentId)} year={year} onClassClick={handleClassClick} />
        </Stack>
    </PageContainer>    
}

